import { useState, useEffect } from 'react';
import { Button, Card, Typography } from 'antd';
import { AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { FileUploadWithGenerateVerificationStatusReportButtonContainer } from './file-upload-with-generate-verification-status-report-button.container';
import { Helmet } from 'react-helmet';

interface FilesProps {
  shared?: boolean;
  caseId: string;
  isAssigned: boolean;
  onUploadSuccess: (response: AzureBlobResponse, fieldName: string) => Promise<void>;
  caseState: string;
  isCaseOrApplicant: string;
}

const { Title } = Typography;

export const Files: React.FC<FilesProps> = (props) => {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setIsEditing(false);
  }, [props.caseState]);

  const verificationPacketFiles: Map<string, string> = new Map();
  verificationPacketFiles.set('coverLetter', 'cover-letter.pdf');
  verificationPacketFiles.set('credential', 'credential.pdf');
  verificationPacketFiles.set('translation', 'translation.pdf');
  verificationPacketFiles.set('verificationPacketResponse', 'verification-packet-response.pdf');
  verificationPacketFiles.set('verificationComponentPacket', 'verification-component-packet.pdf');
  verificationPacketFiles.set('verificationForm', 'verification-form.pdf');
  verificationPacketFiles.set('verificationStatusReport', 'verification-status-report.pdf');
  verificationPacketFiles.set('photo', 'photo.jpg');
  return (
    <>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - Files</title>
      </Helmet>
      <Card hoverable style={{ marginTop: '20px' }}>
        <div className="p-12">
          <div className="flex justify-between">
            <div className="flex flex-col space-y-1">
              <Title level={5}>Private Files</Title>
              <p>(Not Visible to Applicant)</p>
            </div>
            <Button
              type="primary"
              disabled={
                !props.isAssigned || props.caseState === 'draft' || props.caseState === 'decisionRendered' || (props.caseState === 'revisionRequested' && props.isAssigned)
              }
              onClick={() => setIsEditing((prev) => !prev)}
            >
              {isEditing ? 'Editing' : 'Edit'}
            </Button>
          </div>

          <div className="flex flex-col space-y-6 mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start w-full">
              {/* <GenericIdForm title="Verification Form" fileName="verification-form.pdf" fieldName="verificationForm" isEditing={isEditing} canGenerate={true} /> */}

              <FileUploadWithGenerateVerificationStatusReportButtonContainer
                title="Cover Letter"
                caseId={props.caseId}
                verificationFileName="cover-letter.pdf"
                verificationFileNames={verificationPacketFiles}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                isPreviewOnly={!isEditing}
                isUploadPreviewImage={false}
                isCoverLetter={true}
                isShowFileName={false}
                setIsEditing={setIsEditing}
              />
              <FileUploadWithGenerateVerificationStatusReportButtonContainer
                title="Verification Status Report"
                caseId={props.caseId}
                verificationFileName="verification-status-report.pdf"
                verificationFileNames={verificationPacketFiles}
                permittedContentTypes={['application/pdf']}
                permittedExtensions={['pdf']}
                isPreviewOnly={!isEditing}
                isUploadPreviewImage={false}
                isCoverLetter={false}
                isShowFileName={false}
                setIsEditing={setIsEditing}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
